<template>
  <TourFilterPopupWrapper
    :title="title"
    :static-title="headerTitle"
    :is-modal-only="isFullscreen"
    :is-active="isActive"
    filter-key="price"
    :is-disabled-reset-button="isDisabledResetButton"
    :is-scroll="isScroll"
    @apply="handleApply"
  >
    <TourFilterPriceContent v-bind="props" />
  </TourFilterPopupWrapper>
</template>

<script setup lang="ts">
  import { TourFilterPopupWrapper } from '@/entities/filter/popup-wrapper';
  import TourFilterPriceContent from './TourFilterPriceContent.vue';
  import { useTourFilterPriceTitle } from '../../composables/tour/useTourFilterPriceTitle.ts';
  import { useTourFiltersStore, type TTourFiltersState } from '@/entities/filter/store/tour';
  import { locales } from '../../i18n';
  import type { CurrencyCode } from '@/shared/lib/currency';

  interface Props {
    histogram: Record<string, number>;
    minPrice: number;
    maxPrice: number;
    isFullscreen: boolean;
    isScroll: boolean;
    currencyCode: CurrencyCode;
  }

  interface Emits {
    (e: 'apply', isForced: boolean, filterData?: Partial<TTourFiltersState>): void;
  }

  const props = defineProps<Props>();
  const emit = defineEmits<Emits>();

  const { title, headerTitle, isActive } = useTourFilterPriceTitle({
    messages: locales.ru,
    currencyCode: props.currencyCode,
  });

  const filterStore = useTourFiltersStore();

  const isDisabledResetButton = computed(() => {
    return !filterStore.state.price[0] && !filterStore.state.price[1];
  });

  const handleApply = (isForced: boolean) => {
    const filterData: Partial<TTourFiltersState> = {
      price: filterStore.searchState.price,
    };
    emit('apply', isForced, filterData);
  };
</script>

<style lang="scss" scoped>
  :deep(.filter-popup) {
    width: 368px;
    max-width: 100vw;

    .popup__content {
      padding-top: 5px;
    }
  }
</style>
